import Coupon from '@/models/Coupon'
import User from '@/models/User'

export default class CouponPolicy {
	viewAny(_user: User): boolean {
		return false
	}

	view(_user: User, _coupon: Coupon): boolean {
		return false
	}

	create(_user: User): boolean {
		return false
	}

	update(_user: User, _coupon: Coupon): boolean {
		return false
	}

	delete(_user: User, _coupon: Coupon): boolean {
		return false
	}

	restore(_user: User, _coupon: Coupon): boolean {
		return false
	}

	forceDelete(_user: User, _coupon: Coupon): boolean {
		return false
	}

	redeem(user: User, coupon: Coupon): boolean {
		switch (user.role) {
			case 'auditor':
				return coupon.couponable === user.auditor
			case 'broker':
				return coupon.couponable === user.broker
			case 'user':
				return coupon.couponable === user.company
			default:
				return false
		}
	}
}
